export default {
  code: 'tr',
  meta: {
    title: 'Nanovitsa (Нановица), Bulgaristan – Tatul, Momçilgrad ve Kırcaali Köy Rehberi',
    description:
      'Bulgaristan\'ın Kırcaali ili, Momçilgrad belediyesine bağlı Nanovitsa (Нановица) köyü rehberi: bilgiler, tarih, fotoğraflar, etkileşimli harita ve yakın çevredeki görülecek yerler – Tatul\'daki Orpheus kutsal alanı, Momçilgrad, Kırcaali, Perperikon ve daha fazlası.',
    keywords:
      'Nanovitsa, Нановица, Nanovitsa Bulgaristan, Tatul, Orpheus kutsal alanı, Momçilgrad, Kırcaali, Perperikon, Doğu Rodoplar, Bulgaristan köyü',
    ogTitle: 'Nanovitsa (Нановица) – Tatul, Momçilgrad ve Kırcaali Köy Rehberi',
    ogDescription:
      'Bulgaristan\'ın güneyindeki Doğu Rodoplar\'da Nanovitsa köyü ve çevresindeki görülecek yerler hakkında bilgiler, tarih, fotoğraflar ve etkileşimli harita.',
    twitterTitle: 'Nanovitsa (Нановица) – Köy Rehberi, Bulgaristan',
    twitterDescription:
      'Doğu Rodoplar\'da Nanovitsa köyü ve çevresindeki görülecek yerler hakkında bilgiler, tarih, fotoğraflar ve etkileşimli harita.',
    schemaPlaceDescription:
      'Bulgaristan\'ın güneyinde, Doğu Rodoplar\'da, Momçilgrad belediyesine bağlı, Tatul\'daki Trakya kutsal alanına yakın bir köy.',
    schemaTatulName: 'Tatul – Orpheus Trakya kutsal alanı',
    schemaTatulDescription:
      'Momçilgrad belediyesine bağlı Tatul köyü yakınında, yerleşim izleri MÖ 4000 yıllarına uzanan ve Orpheus kültüyle ilişkilendirilen Trakya kutsal alanı.',
  },
  nav: {
    overview: 'Genel bakış',
    explore: 'Keşfet',
    history: 'Tarih',
    places: 'Yerler',
    map: 'Harita',
    gallery: 'Galeri',
    news: 'Haberler',
  },
  hero: {
    eyebrow: 'Kırcaali İli · Bulgaristan',
    lead: 'Bulgaristan\'ın güneyindeki Doğu Rodoplar\'da bir köy – ve komşularının rehberi: Tatul\'daki Trakya kutsal alanı, Momçilgrad kasabası ve il merkezi Kırcaali.',
    exploreBtn: 'Çevreyi keşfedin',
    mapBtn: 'Haritayı görün',
    stats: { elevation: 'Rakım', population: 'Nüfus (2021)', area: 'Yüzölçümü', postal: 'Posta kodu' },
  },
  overview: {
    kicker: '01 · Genel bakış',
    title: 'Doğu Rodoplar\'da bir tepe köyü',
    paragraphs: [
      'Nanovitsa (Нановица), Bulgaristan\'ın Yunanistan sınırındaki en güney ili olan Kırcaali\'ye bağlı Momçilgrad belediyesinde bir köydür.',
      'Köyü çevreleyen Doğu Rodoplar, dalgalı volkanik tepelerden, kadim Trakya kutsal alanlarından ve Bulgar-Türk karışık nüfustan oluşan bir bölgedir. 2011 nüfus sayımında ilin nüfusunun yüzde 66,2\'si kendini Türk, yüzde 30,2\'si Bulgar olarak tanımlamıştır. Bölge aynı zamanda yaban hayatı için bir sığınaktır: Avrupa\'daki yırtıcı kuş türlerinin neredeyse tamamı, ender bulunan kara akbaba ve küçük akbaba dahil, Doğu Rodoplar\'da yaşar.',
      'Nanovitsa\'nın kendisi küçüktür – 2021\'de 456 kişi – ama dikkat çekici bir çevrede yer alır. Tatul\'daki Trakya kutsal alanı bir sonraki köydedir, Momçilgrad kasabası yerel yönetim merkezidir, il merkezi Kırcaali ise Perperikon\'a ve Arda Nehri üzerindeki barajlara açılan kapıdır.',
    ],
    note: 'Lovech ilinde bulunan ve 24 Şubat 2007\'de yerleşim yeri olmaktan çıkarılan aynı adlı köyle karıştırılmamalıdır.',
    panelTitle: 'Nanovitsa\'dan',
    panelNote: 'Kuş uçuşu mesafe ve yön; kara yolu mesafesi değildir.',
  },
  explore: {
    kicker: '02 · Keşfet',
    title: 'Dört yer, tek bir manzara',
    lead: 'Köy ile ona en yakın üç referans nokta arasında geçiş yapın.',
    areas: [
      {
        id: 'nanovitsa',
        label: 'Nanovitsa',
        kicker: 'Köy',
        title: 'Nanovitsa (Нановица)',
        lead: 'Momçilgrad belediyesi içinde kendi muhtarlığı bulunan, Doğu Rodoplar\'da yaklaşık 450 kişilik küçük bir tepe köyü.',
        paragraphs: [
          'Nanovitsa yaklaşık 308 metre rakımda yer alır ve yaklaşık 5,2 kilometrekarelik bir alanı kaplar. 2021 nüfus sayımında 456 kişi yaşamaktaydı. Köy girişindeki tabelalar hem Kiril hem Latin alfabesiyle yazılmıştır; posta kodu 6830\'dur.',
          'Bölge 30 Mayıs 1913\'e kadar Osmanlı yönetimindeydi; Balkan Savaşları\'nın ardından 10 Ağustos 1913\'te Nanovitsa Bulgar yönetimine geçti. Bugün Momçilgrad belediyesine bağlı bir köy muhtarlığıdır (kmetstvo).',
          'Köy, çıkış yolunda tabelalarla gösterilen komşu yerleşimler Neofit Bozvelievo, Lale ve Dzhelepsko arasında yer alır. Çevresinde bir av üssü ve balık tutulan bir baraj bulunur; Tatul\'daki Trakya kutsal alanı da kısa bir mesafededir.',
        ],
        note: 'Lovech ilinde bulunan ve 24 Şubat 2007\'de yerleşim yeri olmaktan çıkarılan aynı adlı köyle karıştırılmamalıdır.',
        facts: [
          ['İl', 'Kırcaali'],
          ['Belediye', 'Momçilgrad'],
          ['Rakım', '308 m'],
          ['Yüzölçümü', '5,2 km²'],
          ['Nüfus', '456 (2021)'],
          ['Posta kodu', '6830'],
        ],
      },
      {
        id: 'tatul',
        label: 'Tatul',
        kicker: 'Trakya kutsal alanı',
        title: 'Tatul ve Orpheus kutsal alanı',
        lead: 'Doğu Rodoplar\'ın en önemli antik alanlarından birinin yanında, taş evlerden oluşan bir köy.',
        paragraphs: [
          'Tatul, Momçilgrad belediyesine bağlı, 319 metre rakımda bir köydür. Adını, yerel Bulgarcada tatula bitkisi (Datura stramonium) için kullanılan sözcükten alır; evlerinin çoğu iyi yontulmuş taş bloklardan yapılmıştır. 2005 yılında 189 kişi yaşamaktaydı.',
          'Köyün üzerinde kadim bir Trakya kutsal alanı yükselir. Yerleşim izleri MÖ 4000 yıllarına kadar uzanır ve kutsal alan MÖ 19.–18. yüzyıllardan itibaren kesintisiz kullanılmıştır. Arkeologlar bu döneme ait yaklaşık 30 kil sunak, çıplak bir erkek figürü şeklinde Demir Çağı\'na ait bir idol ve önemli bir Trakya hükümdarına ait taş bir lahit bulmuştur.',
          'MÖ 4.–1. yüzyıllar arasında tepenin çevresine taş bir sur örülmüş, kısa süre sonra bir tapınak ve bir anıt mezar eklenmiştir. MS 2.–3. yüzyıllarda başka yapılar da eklenmiştir. MS 4. yüzyılın sonu ya da 5. yüzyılın başında alan, savunma kuleli bir Hristiyan yerleşimine dönüştürülmüş; MÖ 12. yüzyılda ve MS 14. yüzyılda depremler alana zarar vermiştir.',
          'Baş arkeolog Nikolay Ovcharov, alanı ölümünden sonra tanrılaştırılmış etkili bir Trakya liderinin kutsal alanı ve mezarı olarak yorumlamakta ve onu Orpheus kültüyle ilişkilendirmektedir. Alan, yenilenen altyapısıyla bir turizm merkezi olarak geliştirilmekte olup köyden Taşlaşmış Orman\'a (Petrified Forest) giden bir patika başlar.',
        ],
        facts: [
          ['Rakım', '319 m'],
          ['Koordinatlar', '41°33′13″K 25°32′28″D'],
          ['Nüfus', '189 (2005)'],
          ['Nanovitsa\'dan', null],
          ['En eski yerleşim', 'MÖ 4000 civarı'],
          ['Kutsal alan kullanımda', 'MÖ 19.–18. yüzyıldan itibaren'],
        ],
      },
      {
        id: 'momchilgrad',
        label: 'Momçilgrad',
        kicker: 'En yakın kasaba',
        title: 'Momçilgrad',
        lead: 'Nanovitsa için yönetim merkezi olan, Türk nüfusun çoğunlukta olduğu ve uzun bir Osmanlı geçmişine sahip, yaklaşık 7.800 kişilik bir kasaba.',
        paragraphs: [
          'Momçilgrad, Doğu Rodoplar\'da 452 metre rakımda yer alır. 2011 nüfus sayımında 7.831 kişi yaşamaktaydı ve nüfusunun yaklaşık yüzde 75\'i Türk olan, Türk nüfusun çoğunlukta bulunduğu en büyük Bulgaristan yerleşimidir.',
          '1934\'e kadar kasabanın adı Mastanlı (Мастанли) idi; Türk sakinleri onu bugün de Mestanlı olarak anar. Birinci Balkan Savaşı\'nın ardından Bulgaristan\'a katılmış ve tarihi bir şahsiyet olan Momçil\'in adıyla yeniden adlandırılmıştır. İki minareli tarihi camisi yaklaşık 300 yıldır kullanılmaktadır.',
          '1969\'da Momçil Voyvoda Caddesi 2 numarada kurulan Momçilgrad Müzesi, Kırcaali ilinde türünün ilk müzesiydi ve bugün yaklaşık 1.200 arkeolojik, etnografik ve doğa tarihi eseri barındırmaktadır. Momçilgrad, 2012\'ye kadar Manş Denizi\'ni en hızlı geçme rekorunu elinde tutan yüzücü Petar Stoychev ile 1967-2017 yılları arasında yaşayan halterci Naim Süleymanoğlu\'nun da doğduğu yerdir.',
          'Momçilgrad belediyesi 358,12 kilometrekarelik bir alanı kaplar ve kasaba ile birlikte Nanovitsa dahil 54 köyden oluşur. 2011\'de nüfusu 16.263 kişiydi.',
        ],
        facts: [
          ['Rakım', '452 m'],
          ['Nüfus', '7.831 (2011)'],
          ['Eski adı', '1934\'e kadar Mastanlı'],
          ['Nanovitsa\'dan', null],
          ['Belediye', '358,12 km², 55 yerleşim'],
          ['Posta kodu', '6800'],
        ],
      },
      {
        id: 'kardzhali',
        label: 'Kırcaali',
        kicker: 'İl merkezi',
        title: 'Kırcaali (Kardzhali)',
        lead: 'Doğu Rodoplar\'ın en büyük şehri ve Bulgaristan\'ın en güney ilinin yönetim merkezi.',
        paragraphs: [
          'Kırcaali, Arda Nehri\'nin iki yakasında, 275 metre rakımda, Sofya\'nın yaklaşık 260 kilometre güneydoğusunda yer alır. Şehrin nüfusu 2011\'de 44.071, 2021\'de 40.659 kişiydi; 117 köyü kapsayan daha geniş belediyenin nüfusu 2011\'de 67.846 kişiydi.',
          'Adını, 18. yüzyılda yaşamış bir Türk eşkıya lideri olan "Kırca Ali"den alır; şehrin Türkçe adı da bu nedenle Kırcaali\'dir. Osmanlı yönetimi, Bulgar general Vasil Delov\'un şehri Birinci Balkan Savaşı sırasında ele geçirmesiyle 21 Ekim 1912\'de sona ermiştir.',
          'Bir zamanlar bir tütün işleme merkezi olan Kırcaali\'nin ekonomisi bugün büyük ölçüde perakende ticaret ve hizmetlere dayanmakta, tarımın işgücü içindeki payı ise artmaktadır. Bölgesel Tarih Müzesi, Kırcaali ve Studen Kladenets barajları ile yaklaşık 15 kilometre kuzeydoğuda yer alan kadim kaya şehri Perperikon, en bilinen görülecek yerleri arasındadır. İklimi, 43,2 °C\'lik rekor sıcaklığıyla sıcak yazlı Akdeniz iklimidir.',
          'Kırcaali ili 3.209,1 kilometrekarelik bir alanı kaplar ve Yunanistan\'a sınırdır. Ardino, Çernooçene, Dzhebel, Kırcaali, Kirkovo, Krumovgrad ve Momçilgrad olmak üzere yedi belediyeden oluşur ve 2021\'de nüfusu 141.177 kişiydi. 1987\'den beri Hasköy (Haskovo) iline bağlıyken 1999\'da yeniden bağımsız bir il olarak kurulmuştur.',
        ],
        facts: [
          ['Rakım', '275 m'],
          ['Nüfus (şehir)', '40.659 (2021)'],
          ['Yüzölçümü (il)', '3.209,1 km²'],
          ['Nanovitsa\'dan', null],
          ['Nehir', 'Arda'],
          ['Belediyeler', 'ilde 7 belediye'],
        ],
      },
    ],
  },
  numbers: {
    title: 'Rakamlarla bölge',
    cards: [
      {
        id: 'nanovitsa',
        name: 'Nanovitsa',
        role: 'Köy',
        value: 456,
        caption: 'nüfus, 2021',
        rows: [
          ['Rakım', '308 m'],
          ['Yüzölçümü', '5,2 km²'],
        ],
      },
      {
        id: 'momchilgrad',
        name: 'Momçilgrad',
        role: 'Kasaba ve belediye merkezi',
        value: 7831,
        caption: 'nüfus, 2011',
        rows: [
          ['Rakım', '452 m'],
          ['Belediye', '16.263 kişi'],
        ],
      },
      {
        id: 'kardzhali',
        name: 'Kırcaali',
        role: 'İl merkezi',
        value: 40659,
        caption: 'nüfus, 2021',
        rows: [
          ['Rakım', '275 m'],
          ['Belediye', '67.846 kişi (2011)'],
        ],
      },
      {
        id: 'kardzhali-province',
        name: 'Kırcaali İli',
        role: 'Bulgaristan\'ın en güney ili',
        value: 141177,
        caption: 'nüfus, 2021',
        rows: [
          ['Yüzölçümü', '3.209,1 km²'],
          ['Belediyeler', '7'],
        ],
      },
    ],
  },
  timeline: {
    kicker: '03 · Tarih',
    title: 'Tepelerde yedi bin yıl',
    lead: 'Kayalık tepelerdeki ilk yerleşimcilerden günümüz nüfus sayımına – bir izi takip etmek için yere göre filtreleyin.',
    filters: [
      { id: 'all', label: 'Tümü' },
      { id: 'tatul', label: 'Tatul' },
      { id: 'perperikon', label: 'Perperikon' },
      { id: 'nanovitsa', label: 'Nanovitsa' },
      { id: 'momchilgrad', label: 'Momçilgrad' },
      { id: 'kardzhali', label: 'Kırcaali' },
    ],
    items: [
      { id: 'perperikon-first-activity', when: 'MÖ 5000 civarı', title: 'Perperikon\'da ilk insan varlığı', text: 'Kırcaali\'nin kuzeydoğusundaki kayalık tepede insan izleri MÖ 5000 yıllarına kadar uzanır.' },
      { id: 'tatul-earliest-settlement', when: 'MÖ 4000 civarı', title: 'Tatul\'da en eski yerleşim', text: 'Tatul köyünün üzerindeki tepedeki en eski yerleşim izleri.' },
      { id: 'tatul-sanctuary-in-use', when: 'MÖ 19.–18. yüzyıl', title: 'Kutsal alan kullanımda', text: 'Bu döneme ait yaklaşık 30 kil sunak kutsal alanda bulunmuştur; alan yüzyıllarca kullanımda kalır.' },
      { id: 'perperikon-medokos', when: 'MÖ 424', title: 'Medokos kendini kral ilan eder', text: 'Sitalkes\'in ölümünün ardından Medokos, Perperikon\'dan kendini Trakya kralı ilan eder, ancak daha sonra devrilir.' },
      { id: 'tatul-wall', when: 'MÖ 4.–1. yüzyıl', title: 'Bir sur kutsal alan tepesini çevreler', text: 'Tepenin çevresine taş bir sur örülür, kısa süre sonra bir tapınak ve bir anıt mezar eklenir.' },
      { id: 'tatul-new-buildings', when: 'MS 2.–3. yüzyıl', title: 'Tatul\'da yeni yapılar', text: 'Roma döneminde kutsal alan kompleksine başka yapılar eklenir.' },
      { id: 'tatul-christian-period', when: 'MS 4. yy sonu/5. yy başı', title: 'Hristiyanlık dönemi', text: 'Tatul kutsal alanı, savunma kuleli bir Hristiyan yerleşimine dönüştürülür; Perperikon\'da da Hristiyan öğeler ortaya çıkar.' },
      { id: 'perperikon-fortress-ends', when: '14. yüzyıl', title: 'Ortaçağ kalesinin sonu', text: 'Perperikon bu tarihe kadar bir Ortaçağ kalesi olarak kullanılmıştır. 14. yüzyılda bir deprem Tatul kutsal alanına da zarar verir.' },
      { id: 'ali-bey-house', when: '1851', title: 'Ali Bey\'in evi', text: 'Bugün Momçilgrad belediyesi sınırlarında yer alan Manchevo köyünde bir ev inşa edilir.' },
      { id: 'kardzhali-liberated', when: '21 Ekim 1912', title: 'Kırcaali\'nin ele geçirilişi', text: 'General Vasil Delov\'un Birinci Balkan Savaşı sırasında şehri ele geçirmesiyle Kırcaali\'de Osmanlı yönetimi sona erer.' },
      { id: 'nanovitsa-joins-bulgaria', when: '30 Mayıs – 10 Ağustos 1913', title: 'Nanovitsa Bulgaristan\'a katılır', text: 'Bölgedeki Osmanlı kontrolü 30 Mayıs\'ta sona erer. 10 Ağustos 1913\'te Nanovitsa Bulgar yönetimine geçer.' },
      { id: 'momchilgrad-renamed', when: '1934', title: 'Mastanlı, Momçilgrad olur', text: 'Kasaba, Osmanlı dönemi adı Mastanlı\'nın yerine resmen Momçil\'in adını taşıyan Momçilgrad olarak yeniden adlandırılır.' },
      { id: 'kardzhali-reservoir-built', when: '1957–1963', title: 'Kırcaali Barajı inşa edilir', text: 'Arda Nehri üzerindeki barajın inşaatı 1957\'de başlar, 1963\'te baraj gölü açılır; çalışmalar 1976\'ya kadar sürer.' },
      { id: 'momchilgrad-museum-opens', when: '1969', title: 'Momçilgrad Müzesi açılır', text: 'Kırcaali ilinde türünün ilk müzesi kurulur; bugün yaklaşık 1.200 eser sergilenmektedir.' },
      { id: 'stone-mushrooms-protected', when: '13 Mayıs 1974', title: 'Taş Mantarlar koruma altına alınır', text: 'Beli Plast yakınındaki kaya oluşumları doğa anıtı ilan edilir.' },
      { id: 'kardzhali-province-restored', when: '1999', title: 'Kırcaali ili yeniden kurulur', text: 'On iki yıl Hasköy iline bağlı kaldıktan sonra il yeniden kurulur.' },
      { id: 'perperikon-excavations-begin', when: '2000', title: 'Sistematik kazılar başlar', text: 'Arkeolog Nikolay Ovcharov, bugün de süren Perperikon\'un sistematik kazılarına başlar.' },
      { id: 'nanovitsa-census-2021', when: '2021', title: 'Nüfus sayımı: 456 kişi', text: '2021 nüfus sayımı Nanovitsa\'da 456 kişinin yaşadığını kaydeder.' },
    ],
  },
  places: {
    kicker: '04 · Yerler',
    title: 'Nanovitsa çevresinde görülecek yerler',
    lead: 'Köye yakın antik şehirler, doğal anıtlar ve tarihi yapılar. Mesafeler Nanovitsa\'dan kuş uçuşu olarak ölçülmüştür.',
    categories: {
      village: 'Köy',
      town: 'Kasaba',
      ancient: 'Antik alan',
      nature: 'Doğa',
      water: 'Su',
      heritage: 'Miras',
    },
    filters: [
      { id: 'all', label: 'Tüm yerler' },
      { id: 'ancient', label: 'Antik alanlar' },
      { id: 'nature', label: 'Doğa' },
      { id: 'water', label: 'Su' },
      { id: 'heritage', label: 'Miras' },
      { id: 'town', label: 'Kasabalar' },
    ],
    items: [
      {
        id: 'nanovitsa',
        name: 'Nanovitsa',
        summary: 'Bu sayfanın konusu olan köy, Momçilgrad belediyesinin tepelerinde yer alır.',
        details: [],
      },
      {
        id: 'tatul',
        name: 'Tatul ve Orpheus kutsal alanı',
        shortName: 'Tatul',
        summary: 'Doğu Rodoplar\'ın en tanınmış Trakya kutsal alanlarından birine sahip, Orpheus kültüyle ilişkilendirilen komşu köy.',
        details: [
          ['Rakım', '319 m'],
          ['En eski yerleşim', 'MÖ 4000 civarı'],
          ['Kutsal alan kullanımda', 'MÖ 19.–18. yüzyıldan itibaren'],
          ['Hristiyanlık dönemi', 'MS 4. yy sonu/5. yy başı'],
        ],
      },
      {
        id: 'perperikon',
        name: 'Perperikon',
        summary: '470 m yüksekliğindeki bir tepeye kayadan oyulmuş, Balkanlar\'ın en büyük megalit topluluğu olarak tanımlanan antik şehir.',
        details: [
          ['Konum', 'Kırcaali\'nin yaklaşık 15 km kuzeydoğusunda'],
          ['Yerleşim', 'MÖ 5000 civarından itibaren'],
          ['Kale surları', '2,8 m kalınlığa kadar'],
          ['Kazılar', '2000\'den beri sistematik, Nikolay Ovcharov yönetiminde'],
          ['Sonraki kullanım', '14. yüzyıla kadar Ortaçağ kalesi'],
        ],
      },
      {
        id: 'petrified-forest',
        name: 'Taşlaşmış Orman',
        summary: 'Raven köyü yakınındaki Gabaz Dere vadisinde, yaklaşık 30 milyon yıllık taşlaşmış ağaçlara sahip korunan bir doğa anıtı.',
        details: [
          ['Yaş', 'yaklaşık 30 milyon yıl'],
          ['Oluşum', 'bir volkanik patlamayla kısmen gömülen kadim bir orman'],
          ['Özelliği', 'gövdelerin hâlâ dik durduğu tek böyle orman olduğu belirtiliyor'],
          ['Başlangıç noktaları', 'Raven, Tatul ve Gurgulitsa'],
        ],
      },
      {
        id: 'stone-mushrooms',
        name: 'Taş Mantarlar',
        summary: 'Kırcaali ile Hasköy arasındaki yol üzerinde, Beli Plast\'ın doğusunda mantar şeklinde kaya oluşumları.',
        details: [
          ['Boyut', 'sap ve şapkalar 2,5 m\'ye kadar'],
          ['Kaya', 'Paleosen\'de su altı volkanik faaliyetinden oluşan riyolitik volkanik tüf'],
          ['Renkler', 'pembe saplar (klinoptilolit) ve yeşil şapkalar (seladonit)'],
          ['Koruma', '13 Mayıs 1974\'ten beri doğa anıtı, 3 hektar alan'],
        ],
      },
      {
        id: 'kardzhali-reservoir',
        name: 'Kırcaali Barajı',
        summary: 'Arda Nehri üzerinde, balıkçılık ve açık hava etkinlikleri için tercih edilen, 103,5 m yüksekliğinde kemer-ağırlık tipi barajıyla büyük bir baraj gölü.',
        details: [
          ['Alan', '16,07 km²'],
          ['Hacim', '497,2 milyon m³ – Bulgaristan\'ın ikinci büyüğü'],
          ['Baraj', '103,5 m yükseklik, 402,89 m uzunluk; Bulgaristan\'daki tek kemer-ağırlık barajı'],
          ['Güç', 'dört türbinden 122 MW'],
          ['İnşaat', '1957\'de başladı, 1963\'te açıldı, çalışmalar 1976\'ya kadar sürdü'],
          ['Görülecek yerler', 'Zavoya nehir kıvrımı ve Patmos Kalesi kalıntıları'],
        ],
      },
      {
        id: 'rock-niches',
        name: 'Neofit Bozvelievo ve Lale kaya nişleri',
        summary: 'Neofit Bozvelievo ile Lale köyleri arasında, ikisi sıra dışı akustik özelliklere sahip kaya nişlerinden oluşan bir ritüel kompleksi.',
        details: [
          ['Nişler', 'iki katta toplam 11 adet'],
          ['Akustik', 'iki niş, önlerinde çıkarılan seslere belirgin bir yankı verir'],
          ['Konum', 'Neofit Bozvelievo\'ya yaklaşık 2 km, Lale yakınında'],
        ],
      },
      {
        id: 'ali-bey-house',
        name: 'Ali Bey\'in Evi, Manchevo',
        summary: '1851\'de Manchevo köyünde inşa edilen, bölgenin 19. yüzyıl mimarisinden korunmuş bir örnek olan tarihi ev.',
        details: [
          ['İnşa tarihi', '1851'],
          ['Köy', 'Manchevo, 647 m rakımda'],
        ],
      },
      {
        id: 'borovets',
        name: 'Borovets Koruma Alanı',
        summary: 'Raven yakınında çam, meşe, yabani armut ve ardıç örtüsünü koruyan bir orman alanı.',
        details: [['Koruduğu', 'çam, meşe, yabani armut ve ardıç ormanı']],
      },
      {
        id: 'momchilgrad',
        name: 'Momçilgrad',
        summary: '1969\'da kurulan bir müzeye ve iki minareli bir camiye sahip, en yakın kasaba ve belediye merkezi.',
        details: [
          ['Rakım', '452 m'],
          ['Nüfus', '7.831 (2011)'],
          ['Müze', 'yaklaşık 1.200 arkeolojik, etnografik ve doğa tarihi eser'],
        ],
      },
      {
        id: 'kardzhali',
        name: 'Kırcaali',
        summary: 'Arda Nehri\'nin iki yakasında yer alan, bir bölge tarih müzesine sahip il merkezi. Perperikon yaklaşık 15 km kuzeydoğusundadır.',
        details: [
          ['Rakım', '275 m'],
          ['Nüfus', '40.659 (2021)'],
          ['Sofya\'ya mesafe', 'yaklaşık 260 km güneydoğu'],
        ],
      },
    ],
  },
  map: {
    kicker: '06 · Harita',
    title: 'Çevrede yönünüzü bulun',
    lead: 'Nanovitsa\'ya olan mesafesini görmek için listeden bir yer seçin veya bir işaretçiye dokunun.',
    ariaMap: 'Nanovitsa ve yakın çevresindeki yerlerin etkileşimli haritası',
    youAreHere: 'Buradasınız',
    showAll: 'Tüm yerleri göster',
    hint: 'Yalnızca koordinatları yayımlanmış yerler işaretlenmiştir. Harita verileri © OpenStreetMap katkıda bulunanları.',
    distanceSuffix: 'Nanovitsa\'ya',
  },
  gallery: {
    kicker: '07 · Galeri',
    title: 'Fotoğraflarla manzara',
    lead: 'Büyütmek için herhangi bir fotoğrafa tıklayın; fotoğraflar arasında gezinmek için ok tuşlarını kullanın.',
    filters: [
      { id: 'all', label: 'Tüm fotoğraflar' },
      { id: 'nanovitsa', label: 'Nanovitsa' },
      { id: 'tatul', label: 'Tatul' },
      { id: 'momchilgrad', label: 'Momçilgrad' },
      { id: 'kardzhali', label: 'Kırcaali' },
      { id: 'region', label: 'Bölgeden' },
    ],
  },
  photos: {
    'village-minaret': { alt: 'Ağaçların ve kırmızı kiremitli bir çatının üzerinde yükselen beyaz bir minare, arkasında tepeler', caption: 'Minare ve kırmızı kiremitli çatılar, arkada Rodop tepeleri' },
    'village-sign': { alt: 'Köyün girişinde Нановица / Nanovitsa yazan yol tabelası', caption: 'Kiril ve Latin alfabesiyle köy tabelası' },
    'village-view': { alt: 'Kuru bir yamaç boyunca görülen, Nanovitsa\'nın kenarındaki evler', caption: 'Köyün kenarındaki evler' },
    'village-road': { alt: 'Taş korkuluklu ve yamaçta evleri olan bir taşra yolu', caption: 'Köyün kenarındaki yol' },
    'village-signpost': { alt: 'Neofit Bozvelievo, Lale ve Dzhelepsko\'yu gösteren mavi yol tabelaları', caption: 'Komşu köyler Neofit Bozvelievo, Lale ve Dzhelepsko\'ya işaret eden tabelalar' },
    'tatul-panorama': { alt: 'Tatul kutsal alanından Doğu Rodoplar\'ın ormanlık tepelerine bakış', caption: 'Tatul kutsal alanından Doğu Rodoplar manzarası' },
    'tatul-niche': { alt: 'Tatul\'da kayaya oyulmuş büyük bir niş', caption: 'Kayaya oyulmuş bir niş' },
    'tatul-summit': { alt: 'Uzakta ormanlık tepelerin bulunduğu Tatul\'un kayalık zirvesi', caption: 'Kutsal alanın kayalık zirvesi' },
    'tatul-rock-niche': { alt: 'Tatul\'da aşınmış kayaya oyulmuş bir niş', caption: 'Tatul kutsal alanında bir kaya nişi' },
    'tatul-sanctuary': { alt: 'Arka planda tepelerin göründüğü, kutsal alandaki bir kaya nişi', caption: 'Tepelere bakan, oyulmuş bir niş' },
    'tatul-excavation': { alt: 'Tatul\'da koruyucu bir çatı altında açığa çıkarılmış açık renkli kaya', caption: 'Koruyucu bir çatı altında açığa çıkarılmış kaya yüzeyi' },
    'momchilgrad-square': { alt: 'Momçilgrad\'da binalar ve ağaçlarla güneşli bir meydan', caption: 'Momçilgrad\'ın ana meydanı' },
    'momchilgrad-center': { alt: 'Ucunda kamu binası bulunan, Momçilgrad\'ın taş döşeli merkez meydanı', caption: 'Taş döşeli merkez meydan' },
    'kardzhali-museum': { alt: 'Kırcaali\'deki Bölge Tarih Müzesi, ortasında kemer bulunan taş bir bina', caption: 'Kırcaali\'deki Bölge Tarih Müzesi' },
    'kardzhali-view': { alt: 'Apartman bloklarının ve bir parkın bulunduğu Kırcaali merkezine bakış', caption: 'Yukarıdan görülen Kırcaali merkezi' },
    'kardzhali-reservoir': { alt: 'Ormanlık tepeler arasında kıvrılan Kırcaali Barajı', caption: 'Arda Nehri üzerindeki Kırcaali Barajı' },
    'perperikon-top': { alt: 'Ormanlık tepelerin üzerinde Perperikon\'un kayalık zirvesi', caption: 'Perperikon\'un kayalık zirvesi' },
    'perperikon-walls': { alt: 'Gün batımı gökyüzüne karşı Perperikon\'da Ortaçağ\'a ait taş bir kule', caption: 'Gün batımında Perperikon\'da bir Ortaçağ kale kulesi' },
    'perperikon-complex': { alt: 'Perperikon arkeolojik kompleksinin çıplak kaya terasları', caption: 'Perperikon kompleksinin kaya terasları' },
    'stone-mushrooms': { alt: 'Açık renkli zeminde mantar şeklinde bir kaya oluşumu', caption: 'Beli Plast yakınında mantar şeklinde bir kaya oluşumu' },
    'stone-mushrooms-dusk': { alt: 'Alacakaranlık gökyüzüne karşı silüeti görünen mantar şeklindeki kayalar', caption: 'Alacakaranlıkta Taş Mantarlar' },
    'studen-kladenets-dam': { alt: 'Altından su akan beton bir baraj duvarı', caption: 'Studen Kladenets\'teki baraj duvarı' },
  },
  footer: {
    tagline: 'Bulgaristan\'ın Kırcaali ili, Momçilgrad belediyesine bağlı Nanovitsa köyü ve çevresindeki yerler hakkında bir bilgi sayfası.',
    sourcesTitle: 'Kaynaklar',
    photosTitle: 'Fotoğraflar ve haritalar',
    photosText: 'Fotoğraflar Wikimedia Commons\'tan alınmıştır ve Creative Commons lisansları altında veya kamu malı olarak kullanılmaktadır; her fotoğrafın altında yazarı ve lisansı belirtilmiştir. Harita verileri © OpenStreetMap katkıda bulunanları. Mesafeler, yayımlanmış koordinatlardan hesaplanan kuş uçuşu tahminlerdir.',
    disclaimer: 'Bilgiler yukarıdaki kamuya açık kaynaklardan derlenmiştir ve değişebilir; seyahat etmeden önce lütfen doğrulayın.',
  },
  common: {
    skip: 'İçeriğe geç',
    menuOpen: 'Menü',
    menuClose: 'Kapat',
    backToTop: 'Başa dön',
    showDetails: 'Ayrıntıları göster',
    hideDetails: 'Ayrıntıları gizle',
    readGuide: 'Tam rehberi okuyun →',
    enlargePrefix: 'Fotoğrafı büyüt:',
    showPhotoPrefix: 'Fotoğrafı göster:',
    zoomHint: 'Büyüt',
    photoViewer: 'Fotoğraf görüntüleyici',
    closeViewer: 'Fotoğraf görüntüleyiciyi kapat',
    previousPhoto: 'Önceki fotoğraf',
    nextPhoto: 'Sonraki fotoğraf',
    filterPlacesAria: 'Yerleri türe göre filtrele',
    filterPhotosAria: 'Fotoğrafları yere göre filtrele',
    filterTimelineAria: 'Zaman çizelgesini yere göre filtrele',
    areasTablistAria: 'Keşfedilecek yerler',
    straightLineTitle: 'Nanovitsa\'dan kuş uçuşu mesafe',
    language: 'Dil',
    directions: ['K', 'KD', 'D', 'GD', 'G', 'GB', 'B', 'KB'],
  },
  news: {
    kicker: '05 · Haberler',
    title: 'Momçilgrad Belediyesi\'nden haberler',
    lead: 'Nanovitsa\'nın bağlı olduğu belediyeden güncel başlıklar; belediyenin kendi sitesindeki orijinal haberlere doğrudan bağlantı verilmiştir.',
    readMore: 'momchilgrad.bg\'de okuyun',
    viewAll: 'momchilgrad.bg\'deki tüm haberler →',
    updated: 'Güncellendi',
    sourceNote: 'Yalnızca başlık ve tarih gösterilmektedir – haberin tamamı için belediyenin kendi sitesine giden bağlantıyı izleyin. Nanovitsa.com bağımsız bir bilgi sayfasıdır ve belediye yönetimiyle bir bağlantısı yoktur.',
    untranslatedNote: 'Henüz çevrilmedi – orijinal Bulgarca başlık gösteriliyor.',
  },
}
